/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Metrics_Wpm_TitleInputs */

const en_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} Words Per Minute`)
};

const fr_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} Mots par minute`)
};

const de_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} Wörter pro Minute`)
};

const it_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} Parole al minuto`)
};

const ru_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} слов в минуту`)
};

const es_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} Palabras por minuto`)
};

const zh_cn2_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} 每分钟字数`)
};

const ja_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} 1分あたりの単語数`)
};

const hi_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} शब्द प्रति मिनट`)
};

const pt_pt2_event_metrics_wpm_title = /** @type {(inputs: Event_Metrics_Wpm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.wpm} Palavras por minuto`)
};

/**
* | output |
* | --- |
* | "{wpm} Words Per Minute" |
*
* @param {Event_Metrics_Wpm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_wpm_title = /** @type {((inputs: Event_Metrics_Wpm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Wpm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_metrics_wpm_title(inputs)
	if (locale === "de") return de_event_metrics_wpm_title(inputs)
	if (locale === "it") return it_event_metrics_wpm_title(inputs)
	if (locale === "ru") return ru_event_metrics_wpm_title(inputs)
	if (locale === "es") return es_event_metrics_wpm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_metrics_wpm_title(inputs)
	if (locale === "ja") return ja_event_metrics_wpm_title(inputs)
	if (locale === "hi") return hi_event_metrics_wpm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_metrics_wpm_title(inputs)
	return en_event_metrics_wpm_title(inputs)
});